import React, { useMemo, useRef, useState } from "react";
import { ReactComponent as SvgIconLang } from "@/assets/icon-lang.svg";
import { ReactComponent as SvgIconDropdown } from "@/assets/icon-dropdown.svg";
import { ReactComponent as SvgIconCheck } from "@/assets/icon-check.svg";
import PopoverPlane, { RefFunctions } from "../popover-plane";
import { classNames } from "@/utils";
import { useTranslation } from "react-i18next";

const LangPicker: React.FC = () => {
  const { i18n } = useTranslation();
  const [active, setActive] = useState(i18n.language || localStorage.getItem("lang") || "en-US");
  const popoverRef = useRef<RefFunctions>(null);
  const langs = [
    { label: "English (US)", value: "en-US" },
    { label: "简体中文", value: "zh-CN" },
    { label: "繁体中文", value: "zh-TW" },
    { label: "日本語", value: "ja-JP" },
    { label: "한국어", value: "ko-KR" },
    { label: "ไทย", value: "th-TH" },
    { label: "ភាសាខ្មែរ", value: "km-KH" },
    { label: "বাংলা", value: "bn-BD" },
    { label: "Bahasa Indonesia", value: "in-ID" },
    { label: "Norsk Bokmål", value: "nb-NO" },
    { label: "Українська", value: "uk-UA" },
    { label: "Dansk", value: "da-DK" },
    { label: "Svenska", value: "sv-SE" },
    { label: "Ελληνικά", value: "el-GR" },
    { label: "Suomi", value: "fi-FI" },
    { label: "Hrvatski", value: "hr-HR" },
    { label: "Српски", value: "sr-RS" },
    { label: "Deutsch", value: "de-DE" },
    { label: "Español", value: "es-ES" },
    { label: "Français", value: "fr-FR" },
    { label: "Italiano", value: "it-IT" },
    { label: "Português (Portugal)", value: "pt-PT" },
    { label: "Polski", value: "pl-PL" },
    { label: "Беларуская", value: "be-BY" },
    { label: "Русский", value: "ru-RU" },
    { label: "Nederlands", value: "nl-NL" },
    { label: "Türkçe", value: "tr-TR" },
    { label: "Čeština", value: "cs-CZ" },
    { label: "Magyar", value: "hu-HU" },
    { label: "Română", value: "ro-RO" },
    { label: "Filipino", value: "tl-PH" },
    { label: "Bahasa Melayu", value: "ms-MY" },
    { label: "Tiếng Việt", value: "vi-VN" },
    { label: "العربية", value: "ar-AR" },
    { label: "اردو", value: "ur-PK" },
    { label: "فارسی", value: "fa-IR" },
    // { label: "עברית", value: "he-IL" },
  ];

  const handleChangeLang = (lang: string) => {
    const pathname = window.location.pathname;
    const url = new URL(window.location as any);
    url.searchParams.set("lang", lang);
    history.replaceState({}, "", url);
    localStorage.setItem("lang", lang);
    if (pathname.indexOf("map-download") > -1) {
      location.reload();
    } else {
      i18n.changeLanguage(lang);
      setActive(lang);
      popoverRef.current.setVisible(false);
    }
  };

  const currentLang = useMemo(() => langs.find((item) => item.value === active), [active]);

  const onRef = (fns: RefFunctions) => {
    popoverRef.current = fns;
  };

  return (
    <>
      <PopoverPlane
        className="lang-picker"
        onRef={onRef}
        content={
          <div className="page-header-dropdown">
            <h3>Language</h3>
            <div className="dropdown-scroll">
              {langs.map((lang) => (
                <div key={lang.value} onClick={() => handleChangeLang(lang.value)} className={classNames({ active: lang.value === active })}>
                  {lang.label}
                  {lang.value === active && <SvgIconCheck />}
                </div>
              ))}
            </div>
          </div>
        }
        placement="bottom-end"
      >
        <SvgIconLang className="icon-earth" />
        {currentLang?.label}
        <SvgIconDropdown className="icon-dropdown" />
      </PopoverPlane>
    </>
  );
};

export default LangPicker;
